import React, { useEffect, useState } from "react";
import ModalSetKeyboardShortcuts from "react-lib/apps/common/ModalSetKeyboardShortcuts";
import { useIntl } from "react-intl";

// MUI
import { makeStyles } from "@mui/styles";
import { Button, Dropdown, Form, Header, Icon, Input, TextArea } from "semantic-ui-react";

const useStyles = makeStyles((theme) => ({
  inputNumber: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
}));

type SubTreatmentRecordProps = {
  handleEvent?: any;
  handleCloseTreatmentRecord?: any;
  selectedTreatmentPerform?: any;
  anestheticOptions?: any[];
  setProp?: any;
  showClinicalFindingTerms?: boolean;
  keyboardShortcut?: any;
  readonly?: boolean;
};

const SubTreatmentRecord = (props: SubTreatmentRecordProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const [record, setRecord] = useState<any>({
    id: null,
    treatment_plan: { id: null, examination: null },
    treatment_record: "",
    anesthetics: null,
    anesthetic_qty: 0,
  });

  useEffect(() => {
    // console.log(props.selectedTreatmentPerform, "596")
    setRecord(props.selectedTreatmentPerform);
  }, [props.selectedTreatmentPerform]);

  const handleChangeTreatmentRecord = (event: any, data: any) => {
    if (data.value && parseFloat(data.value) < 0) {
      // case minus value
      return;
    }
    setRecord({
      ...record,
      [data.name]: data.value,
    });
  };
  const handleKeydownTreatmentRecord = (ev: any) => {
    const shortcutLit = props.keyboardShortcut;
    if (ev.keyCode >= 112 && ev.keyCode <= 123) {
      ev.preventDefault();
      const shortcut = shortcutLit?.find((item: any) => item?.key === ev.key);

      if (shortcut) {
        setRecord({
          ...record,
          treatment_record: `${ev.target.value}${shortcut.other_clinical_finding}`,
        });
      }
    }
  };

  const handleUpdateTreatmentRecord = () => {
    props.handleEvent({
      message: "handleUpdateTreatmentPlanIssue",
      params: {
        pk: record?.id,
        exam_id: record?.treatment_plan?.examination,
        plan_id: record?.treatment_plan?.id,
        treatment_record: record?.treatment_record,
        anesthetics: record?.anesthetics,
        anesthetic_qty: record?.anesthetic_qty,
      },
    });
    props.handleCloseTreatmentRecord();
  };

  return (
    <>
      <Form style={{ margin: "40px 0px" }}>
        <Form.Group inline>
          <Form.Field width={3}>
            <Header as="h4">{intl.formatMessage({ id: "cukey213" })}</Header>
            {!props.readonly ? (
              <Button
                circular
                size="tiny"
                color="yellow"
                type="button"
                onClick={() => props.setProp("showClinicalFindingTermsTreatment", true)}
                style={{ padding: "5px" }}
                icon="cog"
              />
            ) : null}
          </Form.Field>
          <Form.Field width={2}>
            <Header as="h4">{intl.formatMessage({ id: "cukey499" })}</Header>
          </Form.Field>
          <Form.Field width={5}>
            <Dropdown
              selection
              search
              multiple
              className="fluidDropdown"
              options={props.anestheticOptions}
              value={record.anesthetics}
              name="anesthetics"
              disabled={props.readonly}
              style={{ opacity: 1 }}
              onChange={handleChangeTreatmentRecord}
            />
          </Form.Field>
          <Form.Field width={2}>
            <Input
              type="number"
              name="anesthetic_qty"
              min="0"
              value={record.anesthetic_qty || ""}
              onChange={handleChangeTreatmentRecord}
              className={classes.inputNumber}
              step="0.01"
              placeholder="00.00"
              disabled={props.readonly}
            />
          </Form.Field>
          <Form.Field>{intl.formatMessage({ id: "cukey43" })}</Form.Field>
          <Form.Field style={{ flex: 1 }}></Form.Field>

          <Form.Field width={2}>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flex: 1 }}>
              {!props.readonly ? (
                <>
                  <Icon
                    style={{ cursor: "pointer", flex: 1, display: "flex", justifyContent: "flex-end" }}
                    name="photo"
                    size="large"
                    color={props.selectedTreatmentPerform?.activeGallery ? "green" : "grey"}
                    onClick={() => {
                      props.handleEvent({
                        message: "HandleTreatmentIssueGallery",
                        params: {
                          action: "OPEN_GALLERY",
                          treatment_issue: props.selectedTreatmentPerform,
                        },
                      });
                    }}
                  />
                  <Icon
                    style={{ cursor: "pointer", display: "flex", flex: 1, justifyContent: "flex-end" }}
                    name={"edit outline"}
                    size="large"
                    color={props.selectedTreatmentPerform?.activeDrawing ? "green" : "grey"}
                    onClick={() => {
                      props.handleEvent({
                        message: "HandleTreatmentIssueDrawing",
                        params: {
                          treatment_issue: props.selectedTreatmentPerform,
                          action: "OPEN_DRAWING",
                        },
                      });
                    }}
                  />
                </>
              ) : null}
              <Icon
                style={{ cursor: "pointer", flex: 1, display: "flex", justifyContent: "flex-end" }}
                name="close"
                size="large"
                color="grey"
                onClick={props.handleCloseTreatmentRecord}
              />
            </div>
          </Form.Field>
        </Form.Group>
        <Form.Group inline>
          <Form.Field width={16}>
            <TextArea
              rows={4}
              onChange={handleChangeTreatmentRecord}
              name="treatment_record"
              value={record.treatment_record}
              readOnly={props.readonly}
              onKeyDown={handleKeydownTreatmentRecord}
            />
          </Form.Field>
        </Form.Group>
        {!props.readonly ? (
          <Form.Group inline>
            <Form.Field width={2}>
              <Button color="green" style={{ marginTop: "10px" }} onClick={handleUpdateTreatmentRecord}>
                {intl.formatMessage({ id: "cukey187" })}
              </Button>
            </Form.Field>
          </Form.Group>
        ) : null}
      </Form>
      <ModalSetKeyboardShortcuts
        open={props.showClinicalFindingTerms}
        keyboardShortcut={props.keyboardShortcut}
        onClose={() => props.setProp("showClinicalFindingTermsTreatment", false)}
        onCancel={() => props.setProp("showClinicalFindingTermsTreatment", false)}
        onDelete={(data: any) => {
          props.handleEvent({ message: "DeleteKeyboardShortcut", params: { data } });
        }}
        onSave={(data: any) => {
          props.handleEvent({ message: "SaveKeyboardShortcut", params: { data, key_type: "TR" } });
          props.setProp("showClinicalFindingTermsTreatment", false);
        }}
      />
    </>
  );
};

export default SubTreatmentRecord;
